"use client"
import styled from "styled-components";
import Link from 'next/link';
import { theme } from '@/components/features/theme/theme';
import ReactHtmlParser from 'react-html-parser';
import { ImgParallax } from '@/components/common/ui/images/ImgParallax';
import { Img } from '@/components/common/ui/images/Img';
import reactHtmlParser from 'react-html-parser';

const IndustrySingle = ({title, link,  count, img, description}) => {
	return (
		<StyledIndustrySingle className="IndustryV2-single ">
			{
				link &&
				<Link prefetch={true} href={link || '/blog/slug'}></Link>

			}
			<div className="IndustryV2-single__inner__content">
				<h6>{reactHtmlParser(title)}</h6>
				{
					description ?
						<p>{reactHtmlParser(description)}</p> :
						<p>We deliver precision instrumentation services that enhance performance, accuracy, and safety, ensuring your operations run smoothly and efficiently.</p>

				}

				<div className="IndustryV2-single__inner__count">
					<p>{count}</p>
				</div>
			</div>
			<div className="IndustryV2-single__inner">

				<Img src={img} objectFit={'cover'} alt={typeof title === 'string' ? title.replace(/<[^>]*>/g, '') : ''} layout={'fill'} />

			</div>
		</StyledIndustrySingle>
	);
};

const StyledIndustrySingle = styled.div`
    //width: 100%;
    border-radius: 5px;
    overflow: hidden;
	position: relative;
	
	&:after{
		content: "";
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
        background: #DD223F;
        border-radius: 5px;
		height: 0;
		transition: ${theme.transition};
        z-index: 1;
		
	}
    cursor: pointer;
    a {
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        z-index: 3;
    }
	
    .IndustryV2-single__inner {
        padding-top: calc(185 / 370 * 100%);
        position: relative;
        //overflow: hidden;
        cursor: pointer;
		z-index: 0;
        .global-image {
            transition: ${theme.transition};
            transform: scale(1.01);
        }

      

        &__content {
            display: flex;
            padding: 30px;
			background: #DD223F;
			flex-direction: column;
			z-index: 2;
			position: relative;

			p{
                font-weight: 400;
                font-size: 1rem;        /* 16px */
                line-height: 1.5rem;    /* 24px */
                letter-spacing: 0em;    /* 0% */
                color: ${theme.colors.white};
                transition: ${theme.transition};
				transform: translateY(20px);
				opacity: 0;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
			}
            h6 {
                color: ${theme.colors.white};
                font-weight: 500;
                font-size: 1.25rem; /* 20px converted to rem */
                line-height: 1.75rem; /* 28px converted to rem */
                letter-spacing: 0; /* No letter spacing */
                display: flex;
                transition: ${theme.transition};
                transition-delay: 0.3s;
				margin-bottom: 30px;
                @media (min-width: 1336px) {
                    width: 69%;
                }
            }
        }

        &__count {
            position: absolute;
            bottom: -60px;
            text-align: center;
            z-index: 10;
            left: 30px;

            p {
                color: rgba(225, 225, 225, 1);
                font-weight: 400;
                font-size: 7.5rem;       /* 120px ÷ 16 = 7.5rem */
                line-height: 100%;       /* remains the same */
                letter-spacing: 0;       /* 0% = normal spacing */
                transition: ${theme.transition};
				opacity: 1;
				transform: translateY(0);
            }
        }

        &:hover {
            .global-image {
                transform: scale(1.04);
            }

            h6 {
                //color: ${theme.colors.hover};
            }

            p {
                color: rgba(237, 32, 36, 0.3);
            }
        }

    }


	&:hover{
		&:after{
			height: 100%;
		}
		.IndustryV2-single__inner__count{
			p{
				opacity: 0 !important;
			}
		}
		.IndustryV2-single__inner__content{
			p{
				transform: translateY(0);
				opacity: 1;
			}
		}
	}


`;
export default IndustrySingle;
